import {EntityGeometry} from "./EntityGeometry";

export const CreateEntityGeometry = `
    mutation createEntitygeometry ($input: CreateEntitygeometryInput!) {
        createEntitygeometry (input: $input) {
            ${EntityGeometry}
        }
    }
`;
